import React from 'react'

import { Link } from 'react-router-dom'

import { state_options } from '/models/access-key'

# components
import Spinner      from '/components/spinner'
import Pager        from '/components/pager/history-pager'
import StateLabel   from '/components/state-label'
import List         from '/components/list'
import Filters      from '/components/filters'
import Empty        from '/components/empty'

import {
  withListing
  withAccessKeys
} from './queries'

export default \
withListing \
withAccessKeys \
class Events extends React.Component

  render: ->
    return <Spinner/> if @props.listingLoading
    <div className="AccessKeys">
      {@filters()}
      {@list()}
      {@pager()}
    </div>

  filters: ->
    <Filters>
      <Filters.Attribute name="key"/>
      <Filters.State options={state_options}/>
      <span className="pull-right">
        <Pager meta={@props.access_keysPagination} buffer={2}/>
      </span>
    </Filters>

  list: ->
    return <Spinner/> if @props.access_keysLoading
    return <Empty name="Access Keys">
      No access keys match your criteria
    </Empty> unless @props.access_keys?.length

    <List>
      {@header()}
      {for ak in @props.access_keys
        <List.Row key={ak._key}>
          <List.Cell className="key">
            {ak.key}
          </List.Cell>
          <List.Cell className="uses">
            {ak.num_redemptions or 0} / {ak.quantity or 'unlimited'}
          </List.Cell>
          <List.Cell className="applies_to">
            {
              title = (rate.name for rate in ak.rates or []).join "\n"
              switch ak.rates?.length or 0
                when 0
                  <span>all rates</span>
                when 1
                  <span title={title}>1 rate</span>
                else
                  <span title={title}>{ak.rates.length} rates</span>
            }
          </List.Cell>
          <List.Cell className="actions">
            <StateLabel model={ak}/>
          </List.Cell>
        </List.Row>
      }
    </List>

  header:->
    <List.HeaderRow>
      <List.Header className="key"> Key </List.Header>
      <List.Header className="uses"> Uses </List.Header>
      <List.Header className="applies_to"> Applies to </List.Header>
      <List.Header className="actions"> </List.Header>
    </List.HeaderRow>

  pager: ->
    <span className="text-center">
      <Pager meta={@props.access_keysPagination} buffer={4}/>
    </span>
